/* eslint-disable no-nested-ternary */
/* eslint-disable no-invalid-this */

const config = {
  step: 20, // Résolution (augmenter un peu sans dépendance pour perf)
  levels: 10,
  noiseScale: 0.005,
  speed: 0.0005,
  lineWidth: 5,
  thresholds: []
}

const perlin = new (function () {
  this.p = new Uint8Array(512)
  const permutation = new Uint8Array([ 151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10, 23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87, 174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211, 133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208, 89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5, 202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119, 248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232, 178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249, 14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205, 93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180 ])

  for (let i = 0; i < 256; i++) {
    this.p[i] = this.p[i + 256] = permutation[i]
  }

  function fade(t) {
    return t * t * t * (t * (t * 6 - 15) + 10)
  }
  function lerp(t, a, b) {
    return a + t * (b - a)
  }
  function grad(hash, x, y, z) {
    const h = hash & 15
    const u = h < 8 ? x : y
    const v = h < 4 ? y : h === 12 || h === 14 ? x : z

    return ((h & 1) === 0 ? u : -u) + ((h & 2) === 0 ? v : -v)
  }

  this.noise = function (x, y, z) {
    const X = Math.floor(x) & 255
    const Y = Math.floor(y) & 255
    const Z = Math.floor(z) & 255

    x -= Math.floor(x); y -= Math.floor(y); z -= Math.floor(z)
    const u = fade(x), v = fade(y), w = fade(z)
    const A = this.p[X] + Y, AA = this.p[A] + Z, AB = this.p[A + 1] + Z
    const B = this.p[X + 1] + Y, BA = this.p[B] + Z, BB = this.p[B + 1] + Z

    return lerp(w, lerp(v, lerp(u, grad(this.p[AA], x, y, z), grad(this.p[BA], x - 1, y, z)),
      lerp(u, grad(this.p[AB], x, y - 1, z), grad(this.p[BB], x - 1, y - 1, z))),
    lerp(v, lerp(u, grad(this.p[AA + 1], x, y, z - 1), grad(this.p[BA + 1], x - 1, y, z - 1)),
      lerp(u, grad(this.p[AB + 1], x, y - 1, z - 1), grad(this.p[BB + 1], x - 1, y - 1, z - 1))))
  }
})()

const canvas = document.getElementById('topo')
const ctx = canvas.getContext('2d')

let width, height
let time = 0

for (let i = 0; i < config.levels; i++) {
  config.thresholds.push(-0.6 + (i * 1.2 / (config.levels - 1)))
}

function resize() {
  width = canvas.width = window.innerWidth
  height = canvas.height = window.innerHeight
}

window.addEventListener('resize', resize)
resize()

function lerpPos(p1, p2, v1, v2, t) {
  return p1 + (p2 - p1) * (t - v1) / (v2 - v1)
}

function getState(v1, v2, v3, v4, t) {
  return (v1 >= t ? 8 : 0) + (v2 >= t ? 4 : 0) + (v3 >= t ? 2 : 0) + (v4 >= t ? 1 : 0)
}

function animate() {
  ctx.fillStyle = '#050505'
  ctx.fillRect(0, 0, width, height)

  time += config.speed
  ctx.lineWidth = config.lineWidth

  config.thresholds.forEach((threshold, index) => {
    const alpha = 0.05 + (index / config.levels) * 0.8

    ctx.strokeStyle = `rgba(255, 255, 255, ${alpha})`
    ctx.beginPath()

    for (let x = 0; x < width; x += config.step) {
      for (let y = 0; y < height; y += config.step) {

        const v1 = perlin.noise(x * config.noiseScale, y * config.noiseScale, time)
        const v2 = perlin.noise((x + config.step) * config.noiseScale, y * config.noiseScale, time)
        const v3 = perlin.noise((x + config.step) * config.noiseScale, (y + config.step) * config.noiseScale, time)
        const v4 = perlin.noise(x * config.noiseScale, (y + config.step) * config.noiseScale, time)

        const state = getState(v1, v2, v3, v4, threshold)

        if (state === 0 || state === 15) {
          continue
        }

        const top = { x: lerpPos(x, x + config.step, v1, v2, threshold), y: y }
        const right = { x: x + config.step, y: lerpPos(y, y + config.step, v2, v3, threshold) }
        const bottom = { x: lerpPos(x, x + config.step, v4, v3, threshold), y: y + config.step }
        const left = { x: x, y: lerpPos(y, y + config.step, v1, v4, threshold) }

        switch (state) {
          case 1: ctx.moveTo(bottom.x, bottom.y); ctx.lineTo(left.x, left.y); break
          case 2: ctx.moveTo(right.x, right.y); ctx.lineTo(bottom.x, bottom.y); break
          case 3: ctx.moveTo(right.x, right.y); ctx.lineTo(left.x, left.y); break
          case 4: ctx.moveTo(top.x, top.y); ctx.lineTo(right.x, right.y); break
          case 5:
            ctx.moveTo(top.x, top.y); ctx.lineTo(left.x, left.y)
            ctx.moveTo(right.x, right.y); ctx.lineTo(bottom.x, bottom.y)
            break
          case 6: ctx.moveTo(top.x, top.y); ctx.lineTo(bottom.x, bottom.y); break
          case 7: ctx.moveTo(top.x, top.y); ctx.lineTo(left.x, left.y); break
          case 8: ctx.moveTo(top.x, top.y); ctx.lineTo(left.x, left.y); break
          case 9: ctx.moveTo(top.x, top.y); ctx.lineTo(bottom.x, bottom.y); break
          case 10:
            ctx.moveTo(top.x, top.y); ctx.lineTo(right.x, right.y)
            ctx.moveTo(bottom.x, bottom.y); ctx.lineTo(left.x, left.y)
            break
          case 11: ctx.moveTo(top.x, top.y); ctx.lineTo(right.x, right.y); break
          case 12: ctx.moveTo(right.x, right.y); ctx.lineTo(left.x, left.y); break
          case 13: ctx.moveTo(right.x, right.y); ctx.lineTo(bottom.x, bottom.y); break
          case 14: ctx.moveTo(bottom.x, bottom.y); ctx.lineTo(left.x, left.y); break
          default: break
        }
      }
    }
    ctx.stroke()
  })

  requestAnimationFrame(animate)
}

animate()
